// extracted by mini-css-extract-plugin
export default {"chooseForMe":"CaKk6T"};